import s from './Editor.module.scss';
import dynamic from "next/dynamic";
import './editor.scss';
import {useEffect, useState} from "react";
import {convertToRaw, EditorState, RichUtils} from "draft-js";
import {Toolbar} from "@/app/[locale]/common/components/Toolbar/Toolbar";
import {TEditorProps} from "@/app/[locale]/common/components/Editor/types";
import {CUSTOM_STYLED_MAP, FONT_SIZE_STYLES} from "../../constants/news";

const Editor = dynamic(() => import("draft-js").then((mod) => mod.Editor), { ssr: false });

export const EditorComponent = ({ editor = null, handleTextChange }: TEditorProps) => {
    const [editorState, setEditorState] = useState(() => {
        if (editor) {
            try {
                return editor;
            } catch (error) {
                console.error("Error parsing news.text:", error);
            }
        }
        return EditorState.createEmpty();
    });

    useEffect(() => {
        if (editor) {
            try {
                setEditorState(editor);
            } catch (error) {
                console.error("Error parsing news.text:", error);
            }
        }
    }, [editor]);

    const applyInlineStyle = (style: string) => {
        let newState = editorState;

        FONT_SIZE_STYLES.forEach(sizeStyle => {
            if (editorState.getCurrentInlineStyle().has(sizeStyle)) {
                newState = RichUtils.toggleInlineStyle(newState, sizeStyle);
            }
        });

        newState = RichUtils.toggleInlineStyle(newState, style);

        const forceUpdateState = EditorState.forceSelection(newState, newState.getSelection());

        setEditorState(forceUpdateState);
        handleEditorChange(forceUpdateState);
    };

    const handleKeyCommand = (command: string, editorState: EditorState) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            setEditorState(newState);
            return "handled";
        }
        return "not-handled";
    };

    const handleEditorChange = (newEditorState: EditorState) => {
        setEditorState(newEditorState);

        const content = newEditorState.getCurrentContent();
        const rawContent = JSON.stringify(convertToRaw(content));
        handleTextChange(rawContent);
    };

    return (
        <div className={s.editor}>
            <Toolbar applyInlineStyle={applyInlineStyle}/>

            <div className={s.editor_editorWrapper}>
                <Editor
                    editorState={editorState}
                    onChange={handleEditorChange}
                    handleKeyCommand={handleKeyCommand}
                    customStyleMap={CUSTOM_STYLED_MAP}
                />
            </div>
        </div>
    );
};